import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { add_donation } from "../api/donations_api";
import DonationForm from "./DonationForm";
import { useDonationLogic } from "./useDonationLogic"; 
import "../styles/AddDonation.css";

const AddDonation = () => {
    const { donor_id } = useParams();
    const navigate = useNavigate();

    const [exchangeRates, setExchangeRates] = useState({ ILS: 1 });

    const [formData, setFormData] = useState({
        amount: "",
        currency: "ILS",
        date: new Date().toISOString().split('T')[0], 
        paymentMethod: "credit",
        installments: 1,
        status: "pending",
        providerTransactionId: "",
        receipt_id: "",
        notes: "",
        cardHolderName: "",
        cardHolderId: "",
        bankNumber: "",
        bankAccount: "",
        bankBranch: "",
        accountHolder: "",
        manualNote: ""
    });

    
    const handleCreditSuccess = async (updatedData) => {
        try {
            await add_donation(donor_id, updatedData);
            alert("הסליקה בוצעה בהצלחה והתרומה נשמרה!");
            navigate(`/donors/${donor_id}`);
        } catch (e) {
            alert("הסליקה הצליחה אך השמירה במסד הנתונים נכשלה");
        }
    };

   
    const handleSubmit = async (data) => {
        try {
            await add_donation(donor_id, data);
            alert("התרומה נשמרה בהצלחה");
            navigate(`/donors/${donor_id}`);
        } catch (e) {
            alert("שגיאה בשמירת תרומה");
        }
    };

   
    const logic = useDonationLogic({ 
        formData, 
        setFormData, 
        updating: false, 
        onCreditSuccess: handleCreditSuccess 
    });

    return (
        <div className="donation-page">
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>

            <h2 style={{ color: '#150F6B' }}>הוספת תרומה</h2>

            <DonationForm
                formData={formData}
                updating={false}
                logic={logic} 
                onSubmit={handleSubmit}
            />
        </div>
    );
};

export default AddDonation;